module.exports = __webpack_public_path__ + "img/banner3.4d069289.png";